<div class="admin-wizard-controls">
  {{combo-box
    value=this.apiName
    content=this.apiList
    onChange=(route-action "changeApi")
    options=(hash none="admin.wizard.api.select")
  }}

  {{d-button
    action=(route-action "createApi")
    label="admin.wizard.api.create"
    icon="plus"
  }}
</div>

<div class="admin-wizard-container">
  {{outlet}}
</div>